import type { ReactNode } from "react";
import { Tooltip as T } from "radix-ui";
import { cn } from "@/lib/cn";

/**
 * Tooltip with its own provider, so the radix tooltip code only loads with the chunks that use it
 * (keeps it out of the entry bundle). Nested providers are supported by radix.
 */
export function Tooltip({ content, children, side = "bottom", shortcut, className }: { content: ReactNode; children: ReactNode; side?: "top" | "bottom" | "left" | "right"; shortcut?: string; className?: string }) {
  return (
    <T.Provider delayDuration={300} skipDelayDuration={200}>
      <T.Root>
        <T.Trigger asChild>{children}</T.Trigger>
        <T.Portal>
          <T.Content side={side} sideOffset={6} collisionPadding={8} className={cn("z-[60] flex items-center gap-2 rounded-lg bg-slate-900 px-2.5 py-1.5 text-xs font-medium text-white shadow-lg data-[state=delayed-open]:animate-fade-in", className)}>
            {content}
            {shortcut ? <kbd className="rounded bg-white/15 px-1.5 py-0.5 font-sans text-[11px] text-slate-200">{shortcut}</kbd> : null}
          </T.Content>
        </T.Portal>
      </T.Root>
    </T.Provider>
  );
}
